// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  base_url: "https://backend.dev.s9trucks.com",
  base_uri: "/api/v1.0/",
  tile_server_url: "https://map.s9trucks.com/tiles/india",
  tile_api_key: "681d7082afa799a4c9da911f5866f65145d66709a24faf08ee2179a45b543f73",
  razorpay_key: "rzp_test_ImRDXx53av2Ens",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
